<template>
    <CameraModule v-if="model" @update="cameraEvt" @start="startEvt" :blue="blue" :purple="purple"/>
</template>

<script>
import CameraModule from '@/tm/Camera'
import Camera from '@/tm/Camera/scripts/camera.js';
import CustomTmImage from '@/utils/src/CustomTmImage';

export default {
    name: 'ImageModel',
    emits: ['result', 'start'],
    props:{
        blue: {
            type: Boolean,
            default: false,
        },
        purple: {
            type: Boolean,
            default: false,
        },
        model: {
            type: Object,
            default: new CustomTmImage()
        },
        slow: {
            type: Number,
            default: 0
        }
    },
    components: {
        CameraModule,
    },
    data(){
        return {
            slowCounter: 0,
        }
    },
    methods: {
        startEvt(){
            this.$emit('start')
        },
        async cameraEvt(canvas){
            if (!this.model || !this.model.model) {
                return
            }
            if (this.slow) {
                if (this.slowCounter < this.slow) {
                    this.slowCounter++
                    return 
                } else {
                    this.slowCounter = 0;
                }
            }
            const result = await this.model.predict(canvas);
            this.$emit('result', result, canvas) 
        },
    }
}
</script>